var _defs, _path, _polygon, _path2, _polygon2, _path3, _path4, _polygon3, _polygon4, _path5, _path6, _path7, _path8, _rect, _path9, _line, _line2, _line3, _path10, _path11, _g, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteAccountImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#414141;}.cls-3{fill:#f1c391;}.cls-4{fill:#313236;}.cls-5{fill:#000333;}.cls-6{fill:#c4c3c1;}.cls-7{fill:#d11414;}.cls-8{fill:#6e6e6e;}.cls-9{fill:#231f20;stroke:#414141;stroke-linecap:round;stroke-miterlimit:10;}.cls-10{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.14,
    cy: 69.18,
    r: 15.33
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.1,126.65s1.18.1,1.26.11a11.64,11.64,0,0,1,3,.8,7.79,7.79,0,0,1,4.7,7.94c-.16,2.69-1.61,6.38-4.19,7.67Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "73.09 144.36 72.66 149.97 69.71 152.59 62.9 149.94 63 148.56 63.4 143.7 73.09 144.36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.23,147.53c1.46,1,3.94,3.05,9.47,1a6.82,6.82,0,0,1,1.63.45,20.74,20.74,0,0,0,5.55,1.77c2.48.44,5.75,3.8,5.58,5.84s-4.68,2.82-9.54,1.86h0c-.35,0-11.12-1-14.24-1a.39.39,0,0,1-.37-.45l1.35-9.18A.38.38,0,0,1,63.23,147.53Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "51.7 145.18 51.21 150.32 48.27 152.99 41.46 150.33 41.3 148.92 42.08 144.23 51.7 145.18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.54,148.35a8,8,0,0,0,9.72.58.43.43,0,0,1,.44,0,31.4,31.4,0,0,0,6.74,2.75c2.47.44,5.75,3.8,5.57,5.84s-4.69,2.83-9.55,1.85c0,0-12.29-1.06-14.68-1l1.45-9.91A.19.19,0,0,1,41.54,148.35Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.87,77.11s-2.12,14.15-.53,26.17c0,0,.53,13.8.36,19.64,0,0-1.06,20.69-1.42,23.88l10.44-.18,3.36-25.29s1.06-18.22,1.06-22.11c0,0,3.89,18.92,4.42,23.7l2.3,23.7,10.79-.18s-.18-63-1.42-67.92S42.87,77.11,42.87,77.11Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "86.12 94.15 98.39 77.17 112.74 85.35 114.14 90.45 106.02 104.1 86.12 94.15"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "112.74 85.35 110.06 88.03 114.14 90.45 112.74 85.35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.53,45.27s.84,7.85,1,10.33l-8.11.87L65.77,43.56l8.32-.62Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61,23.31s-1.42.78-.8,3.7c.18.83,2.8,1.77,3.15,4.17l-6.46,4.28-9.28-4.71-.05-4.33s2.08-1.3,2.91-6.09C50.94,17.54,61,23.31,61,23.31Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M60.17,27s1.23,4.18-2.44,4.82c0,0-7.39.25-9.45-5.4-.11-.3-1-.4-1.23-.23-1.68,1.12-6.36,2.85-10.21,7,0,0-1.46,3.21-1.93,15.52a34.75,34.75,0,0,0,8,.05l.4,10.3L42.08,65.7s.26,11.41,0,14.72l30.51,1.2s-.4-29.05-1.19-35.28A10.91,10.91,0,0,0,76,45.57s-1.63-9.74-3.22-13.75a24.19,24.19,0,0,0-3.47-2.05A36.83,36.83,0,0,0,60.17,27Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M101.05,158.82,78,158.75c-2.44-.08-5.13-2.29-5.39-4.71l-5-56.59h44.93l-7,56.59C105.2,156.52,103.55,158.9,101.05,158.82Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 67.33,
    y: 92.96,
    width: 45.5,
    height: 4.64
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M115.21,113.48h.16a5,5,0,0,1,5,5v34a5,5,0,0,1-5,5h-.16a0,0,0,0,1,0,0v-44A0,0,0,0,1,115.21,113.48Z",
    transform: "translate(-26.12 28.15) rotate(-12.28)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 78.69,
    y1: 110.14,
    x2: 80.68,
    y2: 147.41
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 100.71,
    y1: 110.14,
    x2: 98.72,
    y2: 147.41
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 88.64,
    y1: 110.27,
    x2: 88.64,
    y2: 147.55
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.65,8.4s.09,8.54-1.48,13.42c0,0-1.52,4.74-8.47,3,0,0-3.92-1.65-5.66-4.75,0,0-.37-.51-.82-1.29A4.77,4.77,0,0,1,46.69,14s.32-2.09,1.77-1.72L49,6.38l7.74-.28L61.51,6l3.15.69Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.84,8.87s1.53-1.6,13.09-.25c0,0,.48.17.39,2.21a.44.44,0,0,0,.28.34,16.93,16.93,0,0,0,.31-2.48s3-3.79-.08-6.95S51.72.84,48.44,4.43c0,0-2.81.88-1.83,5.13,0,0,.91,2.11,1.22,2.75,0,0,1.57,0,2.42,2.4,0,0,.19.8.7.74,0,0,.27-2.18.27-3.27A17.92,17.92,0,0,0,51.84,8.87Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 72.14,
    cy: 69.18,
    r: 15.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.8,67.56s1.42-.21,1.24,1a2.82,2.82,0,0,1-1,1.31,5.84,5.84,0,0,1-1.46.59,5.29,5.29,0,0,1-3.36,3,4.63,4.63,0,0,1-5-1.59,5.57,5.57,0,0,1-1-4.22s-1.81-1.95-.84-3.48a1,1,0,0,1,1.4.31L70,62l5.16-.38,3.29.28,1.11,1.52.32,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.37,72.94a20.63,20.63,0,0,0-.77,2.21L75,76l-2.4,3.25s-3.49-.16-3.52-.18-1.85-2.47-1.85-2.47l.41-3.24,1.28.16s.54-1.41.75-2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62,73.53a31.28,31.28,0,0,1,5.69-.2,16.75,16.75,0,0,0,1.76,4A2,2,0,0,0,71,77.9a21.61,21.61,0,0,0,3.63-2.11,24.18,24.18,0,0,1,4.59,3.5s1.18.59,1.23,3a39.05,39.05,0,0,1,0,5.3L66.47,84,56.36,78.16s3.08-3.83,4.06-4.42A3,3,0,0,1,62,73.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.51,64.3A20,20,0,0,0,70.42,62a7.28,7.28,0,0,1-.77,1.51A4.65,4.65,0,0,0,69,65.19s-.11.07-.22-.09c0,0,0-1-.87-1.1,0,0,.76-5.22,2.9-6.46s10-1.63,9.72,5.43c0,0,1,.69.19,3a13.73,13.73,0,0,1-.84,1.92,1.28,1.28,0,0,0-1-.29s-.33.49-.6.38a15.09,15.09,0,0,1,.29-1.52A8.64,8.64,0,0,1,78.51,64.3Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.61,48.73s-1,11.26-.43,15.38c0,0,19.63,13.26,24.58,15.47,0,0,2.48,5,6.2,5.93,0,0,6.89,1.24,8.49,1.06,0,0,1.68-1.68-3.54-2.92s-5.4-4-5.4-4,.36-1.59,3,0c0,0,1.33.53,1.5-.53s-3.89-2.48-6.1-2.48c0,0-6.37-3.9-9.37-7.79s-10.49-9.71-10.49-9.71.81-7.3.16-10.32C44.22,48.84,39.57,48.89,35.61,48.73Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAccountImg);
export default __webpack_public_path__ + "static/media/deleteAccountImg.0320d74bd63dc16175923dadead8230e.svg";
export { ForwardRef as ReactComponent };